import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Supported languages
const supportedLanguages = ['en', 'ja', 'zh-CN', 'my'];

// Get saved language from localStorage, or default to English
const getSavedLanguage = () => {
  const saved = localStorage.getItem('i18nextLng');
  // Validate that saved language is supported, otherwise default to English
  if (saved && supportedLanguages.includes(saved)) {
    return saved;
  }
  // Default to English on first load or if saved language is invalid
  return 'en';
};

const savedLanguage = getSavedLanguage();

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: {} },
      ja: { translation: {} },
      'zh-CN': { translation: {} },
      my: { translation: {} }
    },
    fallbackLng: 'en',
    lng: savedLanguage,
    debug: process.env.NODE_ENV === 'development', // Enable debug in development
    interpolation: {
      escapeValue: false // React already escapes values
    },
    react: {
      useSuspense: false // Disable suspense for compatibility
    }
  });

// Load translations asynchronously and add them to i18n
const loadTranslations = async () => {
  try {
    const [enResponse, jaResponse, zhCnResponse, myResponse] = await Promise.all([
      fetch('/locales/english/eng_translation.json'),
      fetch('/locales/japanese/jpn_translation.json'),
      fetch('/locales/chinese/zh_cn_translation.json'),
      fetch('/locales/malay/my_translation.json')
    ]);
    
    if (!enResponse.ok || !jaResponse.ok || !zhCnResponse.ok || !myResponse.ok) {
      throw new Error('Failed to load translation files');
    }
    
    const enTranslations = await enResponse.json();
    const jaTranslations = await jaResponse.json();
    const zhCnTranslations = await zhCnResponse.json();
    const myTranslations = await myResponse.json();
    
    // Add translations to i18n resources
    i18n.addResourceBundle('en', 'translation', enTranslations, true, true);
    i18n.addResourceBundle('ja', 'translation', jaTranslations, true, true);
    i18n.addResourceBundle('zh-CN', 'translation', zhCnTranslations, true, true);
    i18n.addResourceBundle('my', 'translation', myTranslations, true, true);
    
    console.log('Translations loaded:', {
      en: Object.keys(enTranslations).length,
      ja: Object.keys(jaTranslations).length,
      'zh-CN': Object.keys(zhCnTranslations).length,
      my: Object.keys(myTranslations).length,
      currentLanguage: i18n.language,
      savedLanguage: savedLanguage
    });
    
    // Always change language to trigger re-render, even if it's the same
    // This ensures components update when translations are loaded
    // Use the validated saved language (defaults to 'en' if invalid)
    const validatedLanguage = getSavedLanguage();
    i18n.changeLanguage(validatedLanguage).then(() => {
      console.log('Language set after translations loaded:', i18n.language);
      // Force emit event to ensure all components update
      i18n.emit('languageChanged', validatedLanguage);
    });
  } catch (error) {
    console.error('Error loading translations:', error);
  }
};

// Load translations in the background
loadTranslations();

export default i18n;

